import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },
  _setItems(state, { items, total }) {
    state.items = items;
    state.pagination.totalItems = total;
    // this.$set(state.pagination, 'totalItems', totalItems)
  },

  setLoading: set("loading"),

  setLoadingNotBilled(state, data) {
    state.loadingNotBilled = data;
  },
  // setSalesCSError: set('salesCSError'),
  setFilters: set("filters"),
  setItemsFilter: set("itemsFilter"),
  setTotalBillings: set("totalBillings"),
  setLoadingTotalBillings: set("loadingTotalBillings"),
  setBillings: set("billings"),
  setItems: set("items"),
  setItemsComplete: set("itemsComplete"),
  setLastItem: set("lastItem"),
  setLoadingBillings: set("loadingBillings"),
  setTotalBilling: set("totalBilling"),
  setDialogDetails: set("dialog_details"),
  setPagination: set("pagination"),
  setTotalItems: set("totalItems"),
  setBillingItems: set("billingItems"),
  setBillingFilters: set("billingFilters"),
  setFaresItems: set("faresItems"),
  setNotBilledUCs: set("notBilledUCs"),
  setFileObject: set("fileObject"),
  setFileName: set("fileName"),
  setUrl: set("url"),
  setName: set("name"),
  setSize: set("size"),
  setType: set("type"),
  setReprocessingDialog: set("reprocessingDialog"),
  setLastModifiedDate: set("lastModifiedDate"),
  setDialogLoading: set("dialog_loading"),
  setMergingInvoices: set("mergingInvoices"),
  setLoadingInvoices: set("loadingInvoices"),
  pushNotBilledUC(state, data) {
    state.notBilledUCs.push(data);
  },
  spliceNotBilledUCs(state, { index, data }) {
    state.notBilledUCs.splice(index, 1, data);
  },
  pushBillingItem(state, data) {
    state.billingItems.push(data);
  },
  spliceBillingItems(state, { index, data }) {
    state.billingItems.splice(index, 1, data);
  },
  setBillingFilterPowerPlant(state, value) {
    state.billingFilters.power_plant_id = value;
  },
  setBillingFilterCompetence(state, value) {
    state.billingFilters.competence = value;
  },
  setBillingFilterStatus(state, value) {
    state.billingFilters.status = value;
  },
  removeCurrentFile(state) {
    state.upload.fileObject = null;
    state.upload.fileName = null;
    state.upload.url = null;
    state.upload.name = null;
    state.upload.size = null;
    state.upload.type = null;
    state.upload.lastModifiedDate = null;
  },
  pushMergingInvoices(state, data) {
    state.mergingInvoices.push(data);
  },
  spliceMergingInvoices(state, { index, data }) {
    state.mergingInvoices.splice(index, 1, data);
  },
};
